import { CoreButtonNextProps as ButtonNextProps } from '../internal/WixUiCoreComponents/components/CoreButtonNext/CoreButtonNext';
import { TPAComponentProps } from '../../types';

export enum ButtonPriority {
  basic = 'basic',
  primary = 'primary',
  secondary = 'secondary',
  basicSecondary = 'basicSecondary',
}

export enum ButtonSize {
  tiny = 'tiny',
  small = 'small',
  medium = 'medium',
  large = 'large',
}
export enum AffixTypes {
  prefix = 'prefix',
  suffix = 'suffix',
}
export enum PaddingModes {
  legacy = 'legacy',
  dynamicPaddings = 'dynamicPaddings',
  explicitPaddings = 'explicitPaddings',
}

export enum HoverStyles {
  colorChange = 'colorChange',
  underline = 'underline',
}

export interface FontConfig {
  size: string;
  lineHeight: string;
}

export type FontConfigByDevice = {
  mobile: FontConfig;
  desktop: FontConfig;
};

export type FontConfigMap = {
  [K in PaddingModes]: {
    [S in ButtonSize]: FontConfigByDevice;
  };
};

export interface ButtonProps extends ButtonNextProps, TPAComponentProps {
  priority?: ButtonPriority;
  size?: ButtonSize;
  fullWidth?: boolean;
  innerRef?: React.RefObject<HTMLButtonElement>;
  upgrade?: boolean;
  /** Choose padding styling approach. legacy | upgrade | explicitPaddings */
  paddingMode?: PaddingModes;
  /** In case you would like to display a button with multiline. Optional. The default is false. */
  wrapContent?: boolean;
  /** Hover style. For better a11y, choose `underline`. The default is `underline`. */
  hoverStyle?: HoverStyles;
}
